import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/storage'
import {
  baseURL
} from '@/utils/config.js'
// 创建axios实例
const service = axios.create({
  baseURL: baseURL, // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.state.user.token) {
    config.headers['mytoken'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  // 确保返回 Error 对象而不是原始错误对象
  const err = error instanceof Error ? error : new Error(error?.message || '请求配置错误')
  return Promise.reject(err)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    if(response.config.responseType === 'blob'){
      return response;
    }
    /**
    * code为非200是抛错 可结合自己业务进行修改
    */
    const res = response.data
    if (res.code !== 200) {
      // 确保错误消息是字符串
      let errorMsg = '请求失败';
      if (res.msg) {
        errorMsg = typeof res.msg === 'string' ? res.msg : JSON.stringify(res.msg);
      }
      Message({
        message: errorMsg,
        type: 'error',
        duration: 3 * 1000
      })

      // 401:未登录;
      if (res.code === 401) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject(new Error(errorMsg))
    } else {
      const data = response.data
      if (Array.isArray(data.rows)) {
        return {
          data: data.rows,
          total: data.total,
          code: data.code,
          msg: data.msg,
        }
      }
      return {
        data: data.obj === undefined ? {} : data.obj,
        code: data.code,
        msg: data.msg,
      }
    }
  },
  error => {
    // 改进错误日志输出
    console.error('Request Error:', error)
    const errorMessage = error.response?.data?.msg || error.message || '网络请求失败'
    Message({
      message: errorMessage,
      type: 'error',
      duration: 3 * 1000
    })
    // 确保返回 Error 对象而不是原始错误对象
    // 如果 error 已经是 Error 实例，直接返回；否则创建一个新的 Error
    if (error instanceof Error) {
      return Promise.reject(error)
    } else {
      const err = new Error(errorMessage)
      // 保留原始错误信息
      if (error.response) {
        err.response = error.response
      }
      if (error.config) {
        err.config = error.config
      }
      return Promise.reject(err)
    }
  }
)

export default service
